import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar: React.FC = () => {
  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(28, 56, 84, 0.95)",
        padding: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
      }}
    >
      <Link
        to="/"
        style={{
          color: "#fff",
          textDecoration: "none",
          fontSize: "1.2rem",
          fontWeight: "bold",
        }}
      >
        Zuz
      </Link>

      <div
        style={{
          display: "flex",
          gap: "2rem",
        }}
      >
        <Link
          to="/privacy-policy"
          className="nav-link"
          style={{ color: "#fff", textDecoration: "none" }}
        >
          Privacy Policy
        </Link>
        <Link
          to="/delete-account"
          className="nav-link"
          style={{ color: "#fff", textDecoration: "none" }}
        >
          Delete Account
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
